<template>
  <with-actions>
    <p class="mb-0 text-muted">
      <span>{{ 'found' | t }} {{ record_count }}</span
      ><span class="pl-1" v-if="record_count === 1">{{ 'invoice' | t | lowercase }}</span
      ><span class="pl-1" v-else>{{ 'invoices' | t | lowercase }}</span>
    </p>
    <lazy-table
      ref="table"
      v-model="invoices"
      model="invoices"
      :params="query"
      :autoload="false"
      @meta="(x) => (record_count = x.record_count)"
    >
      <invoice-filters @change="update_query" slot="header"></invoice-filters>
      <div class="m-3 mt-4">
        <invoices-table :invoices="invoices" :show_customer="true"></invoices-table>
      </div>
    </lazy-table>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import showFile from './../../utils/show_file';

export default {
  data: function () {
    return {
      record_count: 0,
      invoices: [],
      query: {
        filter: {},
        sort: '-id',
        include: 'customer'
      }
    };
  },
  watch: {
    query: {
      deep: true,
      handler() {
        this.$refs.table.load_debounce(true);
      }
    }
  },
  methods: {
    showFile,
    update_query(q) {
      this.query.filter = q.filter;
    }
  },
  mounted: function () {
    this.setBreadcrumbs([{ to: { name: 'invoices' }, text: 'Invoices' }]);
  }
};
</script>

<style scoped>
table.table th,
table.table td {
  border-top: none;
}
</style>
